import { Schema as S } from "effect";
export const Schema = S.Union(S.TemplateLiteral(S.Literal("ch_"), S.String), S.TemplateLiteral(S.Literal("py_"), S.String)).pipe(S.brand("@open-revenue/schema/stripe/ChargeId"), S.annotations({
    identifier: "@open-revenue/schema/stripe/ChargeId",
    description: "The id of the charge or payment in Stripe (ch_* or py_*)",
    examples: [
        "ch_1234567890",
        "py_1234567890"
    ]
}));
export const make = (chargeId)=>S.decodeUnknown(Schema)(chargeId);
export const makeUnsafe = (chargeId)=>chargeId;
